import * as React from "react";
import SalaryCalculatorForm from "./salary-calculator-form";
import styled from "styled-components";

interface SalaryCalculatorFormBlockProps {}

const SalaryCalculatorFormBlock = (props: SalaryCalculatorFormBlockProps) => {
    return (
        <div className="goodgrowth-theme-styles">
            <SalaryCalculatorForm/>
        </div>
    )
}

/** STYLES */

export default SalaryCalculatorFormBlock



// WEBPACK FOOTER //
// ./src/layouts/salary-calculator-form-block/salary-calculator-form-block.tsx